import { Upload } from 'hljd'
import React, { Component } from 'react'
import { addChangeAttr, picPrevCheck, videoPrevCheck } from '../../utils'

class UploadVideo extends Component {
  onChangeHandler(val) {
    this.props.onChange(val)
  }

  render() {
    const { value } = this.props
    const imageValue = value?.filter(e => e.type.includes('image')) || []
    const videoValue = value?.filter(e => e.type.includes('video')) || []

    const labelStyle = {
      backgroundColor: '#fafafa',
      color: '#666',
      width: 90,
      padding: 10,
      lineHeight: 1.5,
      textAlign: 'center'
    }

    const labelStyle1 = {
      ...labelStyle,
      borderTop: '1px solid #e2e2e2'
    }

    const tableStyle = {
      border: '1px solid #e2e2e2',
      width: '100%'
    }

    const areaStyle = {
      paddingTop: 10,
      paddingLeft: 10
    }

    const areaStyle1 = {
      ...areaStyle,
      borderTop: '1px solid #e2e2e2'
    }

    return (
      <div style={{ marginTop: 9 }}>
        <p style={{ lineHeight: 'initial', marginBottom: 8 }}>
          如需认证，必须上传婚礼现场原片或视频。图片大小不能超过
          50MB，视频大小不能超过 500 MB
        </p>
        <table style={tableStyle}>
          <tbody>
            <tr>
              <td style={labelStyle}>婚礼现场照片</td>
              <td style={areaStyle}>
                <Upload
                  // eslint-disable-next-line no-undef
                  tokenFrom={{
                    image: 'proofMaterialImage'
                  }}
                  multiple
                  accept="image/*"
                  upText="点击上传"
                  max={50}
                  onChange={val =>
                    this.onChangeHandler(addChangeAttr(videoValue.concat(val)))
                  }
                  beforeUpload={picPrevCheck}
                  value={imageValue}
                />
              </td>
            </tr>
            <tr>
              <td style={labelStyle1}>婚礼现场视频</td>
              <td style={areaStyle1}>
                <Upload
                  tokenFrom={{
                    video: 'proofMaterialVideo'
                  }}
                  upText="点击上传"
                  accept="video/*"
                  clipOnUpComplete
                  clipable={false}
                  listMode
                  listType="picture-card"
                  previewable
                  max={10}
                  progress={{
                    strokeWidth: 5,
                    format: percent => ~~percent + '%'
                  }}
                  onChange={val =>
                    this.onChangeHandler(addChangeAttr(imageValue.concat(val)))
                  }
                  beforeUpload={videoPrevCheck}
                  value={videoValue}
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    )
  }
}

export default UploadVideo
